<template>
<div class="chapter">
<div class="inner_page">
      ﻿



<title>Draycott Everlasting</title>
<link href="pdlmsr.css" rel="stylesheet" type="text/css"/>
<meta content="application/xhtml+xml; charset=utf-8" http-equiv="content-type"/>
<link href="page-template.xpgt" rel="stylesheet" type="application/vnd.adobe-page-template+xml"/>
<div class="part" id="opt02"><div class="partHead" id="ph02"><a id="page41"><h2 class="partNumber"><span class="bold"><span>PART TWO</span></span></h2><h2 class="partTitle">The Gift</h2><p class="partSubtitle"><span>Night cannot hold,<br/>
Nor forest gain…</span></p></a><a id="page42"></a></div><div class="partBody"></div></div>
<a id="page42">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// draycotteverlasting_opt02.vue?1dd8cac1